import {createStyles, Theme} from "@material-ui/core";
import {buttonContained, errorColor, greyInput, styleColors} from "src/main.style";

export const EditActionStyle = (theme: Theme) => createStyles({
  buttonContained,
  greyInput,
  pane: {
    padding: '10px',
    gap: '10px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  paneStep : {
    width:'100%',
    height:'100%',
    transition:'all 0.3s',
    boxSizing: 'border-box',
    position: 'absolute',
  },
  handoverGroupTitle : {
    fontWeight: 600,
    fontSize: '20px',
    fontStyle: 'italic',
  },
  handoverDay : {
    backgroundColor: styleColors.greyLight2,
    borderRadius: '5px',
    padding: '10px 0px 10px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  handoverTitleRow : {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  handoverDayTitle : {
    fontSize: '20px',
    fontWeight: 500,
  },
  handoverDayDetails : {
    display: 'flex',
    flexDirection: 'column',
  },
  handoverDayOccurences : {
    textAlign: 'right',
    fontSize: '12px',
  },
  paneOptions : {
    display:'flex',
    width: '100%',
    textAlign: 'center',
    placeContent: 'center',
    alignItems: 'center',
  },
  paneOption : {
    width: 'calc(100%/3)',
  },
  paneCenter : {
    minHeight:'20px',
    display:'flex',
    flexDirection:'column',
    justifyContent: 'center',
  },
  paneInfo : {
    display:'flex',
    flexDirection:'row',
    alignSelf: 'center',
    alignItems: 'center',
    gap: '3px',
  },
  templateCalendarDay : {
    height:'20px',
    borderRadius: '3px',
  },
  templateCalendar: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    alignItems: 'center',
    gap: '4px',
    width: '60%',
    margin: '16px 34px',
  },
  templateTitle : {
    display: 'flex',
    alignItems: 'center',
  },
  checkIcon : {
    height: '24px',
    marginRight: '10px',
    color: styleColors.successGreen,
  },
  templateHideCalendar : {
    overflow:'hidden',
    transition: 'all 0.3s',
  },
  gradientButton : {
    borderRadius: '99px',
    border: `1px solid ${styleColors.blackAlpha23}`,
    background: `linear-gradient(45deg, ${styleColors.coralRed} -1%, ${styleColors.softPeriwinkle} 101%)`,
    padding: '10px 24px',
  },
  checkboxLabel : {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
  },
  checkbox : {
    margin: '2px 4px 2px 2px',
    backgroundColor: styleColors.white,
    appearance: 'none',
    WebkitAppearance: 'none',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    padding: '2px',
    border: `1px solid ${styleColors.black}`,
    borderRadius: '2px',
    "&::before": {
      content: "''",
      width: '12px',
      height: '12px',
      clipPath: 'polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%)',
      transform: 'scale(0)',
      // same purple as before in light mode, lighter in dark mode so the cross stays readable
      backgroundColor: styleColors.deepPurple,
      transition:'transform 0.1s',
    },
    "&:checked::before":{
      transform: 'scale(1)',
    }
  },
  textInput : {
    border: `1px solid ${styleColors.black}`,
    margin: '2px',
    display: 'flex',
    padding: '3px',
    fontSize: '14px',
    minHeight: '18px',
    alignContent: 'center',
    borderRadius: '2px',
    justifyContent: 'center',
    backgroundColor: styleColors.white,
    "&:disabled":{
      opacity: 0.7,
      border: `1px solid ${styleColors.greyMedium1}`,
    }
  },
  textInputLine : {
    display: 'flex',
    alignItems: 'center',
  },
  errorText : {
    color: errorColor,
    fontSize: '13px',
    marginTop: '6px',
  },
  locationInput : {
    marginLeft: '12px',
    flex: 1,
    minWidth: '100px',
  },
  wizardCal : {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gridColumnGap: '4px',
    gridRowGap: '8px',
    border: `1px solid ${styleColors.greyMedium1}`,
    padding: '6px 4px 4px',
    borderRadius: '4px',
    backgroundColor: styleColors.greyLight1,
  },
  wizardDay : {
    minHeight:"24px",
    borderRadius: '4px',
  },
  wizardDayHeader : {
    fontSize: '12px',
    borderBottom: `1px solid ${styleColors.greyMedium1}`,
    textAlign: 'center',
  },
  backButton : {
    textAlign: 'start',
  },
  calendarTitle : {
    width: '100%',
    height: '35px',
    fontSize: '16px',
    fontWeight: 600,
    color: styleColors.greyDark3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  calendarDays : {
    width: 'calc(100% / 7)',
    textAlign: 'center',
    overflow: 'hidden',
    fontWeight: 200,
    borderTop: `1px solid ${styleColors.blackInset33}`,
    textTransform: 'uppercase',
    fontSize: '10px',
    padding: '4px 0px',
  },
});




// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/EditAction.style.ts